// Frappe Translation normalizes HTML source strings to plain text on save.
export const menuSourceKey = (text) => String(text ?? "").replace(/<[^>]*>/g, "").trim();
export const translateMenuText = (text, language, translations = {}) => {
    if (language !== "ar" || typeof text !== "string") return text;
    let key = Object.prototype.hasOwnProperty.call(translations, text) ? text : menuSourceKey(text);
    if (!Object.prototype.hasOwnProperty.call(translations, key)) {
        // Translation source uniqueness follows the database's case-insensitive collation.
        key = Object.keys(translations).find((source) => source.toLowerCase() === key.toLowerCase()) ?? key;
    }
    return Object.prototype.hasOwnProperty.call(translations, key) && translations[key] ? translations[key] : text;
};
